import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import Fuse from 'fuse.js';
import IntlComponent from 'axway-react-intl';
import { PageHeader, SearchBar } from 'axway-react-ui';
import { Button, Glyphicon, Tab, Tabs, Alert } from 'react-bootstrap';
import ComponentsTabView from './ComponentsTabView';

class ComponentsListView extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.onSearch = this.onSearch.bind(this);
		this.renderTab = this.renderTab.bind(this);
		this.state = {
			searchFilter: ''
		};

		// distance x threshold = no. of chars it will search within (starting
		// from the left)
		this.fuseOpts = {
			threshold: 0.1,
			distance: 1000,
			shouldSort: true,
			keys: [ 'name', 'description', 'package' ]
		};
		this.fuse = new Fuse(props.items, this.fuseOpts);
	}

	onSearch(filter) {
		this.setState({
			searchFilter: filter.trim()
		});
	}

	/**
	 * Filters the components displayed.
	 */
	applySearchFilter(items) {
		if (this.state.searchFilter) {
			return this.fuse.search(this.state.searchFilter);
		}
		return items;
	}

	componentWillReceiveProps(props) {
		this.fuse = new Fuse(props.items, this.fuseOpts);
	}

	renderTab(tabIndex, items, label, icon, hasAlert) {
		const { searchFilter } = this.state;
		const { onInstallRequest, onUninstallRequest } = this.props;
		return (
			<Tab
				eventKey={tabIndex}
				title={(
					<span>
						<span className={`tab-icon gg icon-GG-${icon}`} />
						{label} (<b>{items.length}</b>)
					</span>
				)}
			>
				{hasAlert ? (
					<Alert bsStyle="warning">
						{this.intl.formatMsg('Community plugins are not directly supported by Axway and are supported by their respective publishers. They are listed without Axway support or warranty.')}
					</Alert>
				) : null}
				<ComponentsTabView
					type={label}
					components={items}
					searchFilter={searchFilter}
					onInstallRequest={onInstallRequest}
					onUninstallRequest={onUninstallRequest}
				/>
			</Tab>
		);
	}

	render() {
		const { items } = this.props;
		const components = this.applySearchFilter(items);
		const filteredItems = {
			installed: [],
			axway: [],
			community: []
		};

		for (const component of components) {
			if (component.installed) {
				filteredItems.installed.push(component);
			} else if (component.tags.includes('axway')) {
				filteredItems.axway.push(component);
			} else {
				// If it's not axway then it's community, no need to check
				filteredItems.community.push(component);
			}
		}

		const installedLabel = this.intl.formatMsg('Installed plugins');
		const officialLabel = this.intl.formatMsg('Axway supported plugins');
		const communityLabel = this.intl.formatMsg('Community plugins');
		const summary = this.intl.formatMsg('The plugins listed on this page extend the core functionality of API Builder and can be used to connect to different data sources and services or enhance the Flow editor.');

		return (
			<div className="components-view">
				<PageHeader>
					<PageHeader.Section align="left" compact>
						<PageHeader.Title
							infoPopover={{
								id: 'plugins-info',
								description: summary,
								docLink: window.$conf.docComponentsUrl
							}}
						>
							{this.intl.formatMsg('Plugins')}
						</PageHeader.Title>
					</PageHeader.Section>

					<PageHeader.Section />

					<PageHeader.Section>
						<SearchBar
							onChange={this.onSearch}
							throttle={50}
						/>
					</PageHeader.Section>

					<PageHeader.Section align="right">
						<Button
							bsStyle="link"
							className="create-component-link"
							href={window.$conf.docPluginsSDKUrl}
							target="_blank"
						>
							<Glyphicon glyph=" gg icon-GG-share" />
							<span>{this.intl.formatMsg('Create plugin')}</span>
						</Button>
					</PageHeader.Section>
				</PageHeader>
				<div className="content">
					<Tabs
						id="plugins-tabs"
						className="axui"
						animation={false}
					>
						{this.renderTab(0, filteredItems.axway, officialLabel, 'axway-new')}
						{this.renderTab(1, filteredItems.community, communityLabel, 'github', true)}
						{this.renderTab(2, filteredItems.installed, installedLabel, 'download2')}
					</Tabs>
				</div>
			</div>
		);
	}
}

ComponentsListView.propTypes = {
	items: PropTypes.array.isRequired,
	onInstallRequest: PropTypes.func.isRequired,
	onUninstallRequest: PropTypes.func.isRequired
};

export default injectIntl(ComponentsListView);
